import { Alert, Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { plural } from "../../../../utils/utilityFunctions";
import MickUploadBox from "../../../upload/MickUploadBox";

export default function IcpInspectionStepAsBuilt({
    formState: {asBuiltFileObjects, phaseList },
    dispatch,
    onBack,
    onNext,
    workOrderId,
    networkApprovedPhaseList,
    }) {

    const [isUploading, setIsUploading] = useState(false)

    const bffPath = `/bff/icp-livening-service/api/new-connections/as-builts/upload-document/${workOrderId}`

    /**
     * 
     * @param {boolean} isUploaderBusy 
     * @param {Array<object>} fileChangeSpecs // E.g. [{action: 'Add', file: {fileKey: "...", url: "..."}}, ...]
     * Records uploader busy status in state.
     * Uses dispatch function to update asBuiltFileObjects parameter with any file changes received.
     */
    const handleAsBuiltUploadStatusChange = (isUploaderBusy, fileChangeSpecs) => {
        console.log('handleAsBuiltUploadStatusChange got fileChangeSpecs', fileChangeSpecs)
        setIsUploading(isUploaderBusy)
        if (fileChangeSpecs?.length > 0) {
            dispatch({type: 'asBuiltFileObjects', value: fileChangeSpecs}) 
        }
    }

    /**
     * 
     * @param {string[]} selectedPhasesList E.g. ['Red', 'White']
     * @param {object} approvedPhaseObject E.g. {red: false, white: true, blue: true}
     * @returns boolean
     */
    const selectedPhaseMatchesApprovalPhase = (selectedPhasesList, approvedPhaseList) => {

        console.log('selectedPhaseMatchesApprovalPhase selectedPhasesList', selectedPhasesList)
        console.log('selectedPhaseMatchesApprovalPhase approvedPhaseList', approvedPhaseList)

        const selectedButNotApproved = selectedPhasesList.filter(s => !approvedPhaseList.includes(s))
        if (selectedButNotApproved.length > 0) {
            // console.log('selectedButNotApproved', selectedButNotApproved) 
            return false
        }

        const approvedButNotSelected = approvedPhaseList.filter(a => !selectedPhasesList.includes(a))
        if (approvedButNotSelected.length > 0) {
            // console.log('approvedButNotSelected', approvedButNotSelected) 
            return false
        }

        // console.log('selectedPhaseMatchesApprovalPhase return TRUE') 
        return true
    }

    return (
        <Box>
            <Typography variant="h4" sx={{mb:3}}>As Built Photos</Typography>
            <Typography variant="body2" sx={{mb:3}}>Please take up to six photos of the meter and its connections.</Typography>
            {
                networkApprovedPhaseList.length > 0 && !selectedPhaseMatchesApprovalPhase(phaseList, networkApprovedPhaseList)
                &&
                <Alert severity="info">
                    Please take a photo of the {phaseList.join(', ')} phase{plural(phaseList.length)} you have inspected.
                    The Network Approval specifies {networkApprovedPhaseList.join(', ')} phase{plural(networkApprovedPhaseList.length)}.
                </Alert>
            }
            <Box sx={{display: 'flex', flexDirection: 'column', mt: 3 }}>
                <MickUploadBox
                    bffPath={bffPath}
                    initialFiles={asBuiltFileObjects}
                    statusChange={handleAsBuiltUploadStatusChange}
                />
            </Box>
            <Box sx={{ my: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Button onClick={onBack} disabled={isUploading}>Back</Button>
                <Button onClick={onNext} disabled={isUploading} variant="contained">Next</Button>
            </Box>
        </Box>
    )
}